// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3412 ? "ff305c4b" : chunkId) + "." + {"1464":"515563211f44af94","3412":"3dfcd8f3f2cb248e","5467":"49934e60644aa0e8","9144":"d007c1371752ee38","9433":"7d3205888df54454"}[chunkId] + ".js";
};